'use client';

import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

export interface HeaderContact {
  email: string;
  phone: string;
}

export interface HeaderSocialLink {
  id: string;
  platform: 'facebook' | 'instagram' | 'linkedin' | 'twitter';
  url: string;
}

import { IFooter } from "@/services/types";

export interface TopHeaderProps {
  data: IFooter;
}

export const TopHeader: React.FC<TopHeaderProps> = ({ data }) => {
  return (
    <section className="w-full h-8 bg-black/45 border-b border-white/10 xl:bg-gray-50 xl:border-neutral-200">
      <div className="w-full container mx-auto h-full px-6 flex items-center justify-end gap-4">
        {/* Informações de Contato */}
        <div className="flex items-center gap-8">
          {/* Email */}
          {data.contact[0]?.label && (
            <a
              href={`mailto:${data.contact[0]?.url}`}
              className="flex items-center gap-2 text-white/80 text-xs font-light lowercase hover:text-white xl:text-neutral-500 xl:hover:text-neutral-700 transition-colors"
              title={data.contact[0].url}
            >
             
              {data.contact[0].label}
            </a>
          )}

          {/* Telefone */}
          {data.contact[1]?.label && (
            <a
              href={`tel:${data.contact[1].url}`}
              className="flex items-center gap-2 text-white/80 text-xs font-light hover:text-white xl:text-neutral-500 xl:hover:text-neutral-700 transition-colors"
              title={data.contact[1].url}
            >
              
              {data.contact[1].label}
            </a>
          )}
        </div>

        {/* Redes Sociais */}
        <div className="flex items-center gap-4">
          {data.social_midia?.map((social) => (
            <Link
              key={social.name}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-4 h-4 text-neutral-500 B hover:text-neutral-700  transition-colors hover:text-orange-300 hover:scale-110 cursor-pointer"
              title={social.name}
              aria-label={`Link para ${social.name}`}
            >
              <Image
                src={social.logo.url || '/logo-fpef.svg'}
                alt={social.name}
                width={social.logo.width ?? 1}
                height={social.logo.height ?? 1}
                className="w-full h-full brightness-0 invert opacity-80 xl:brightness-100 xl:invert-0 xl:opacity-100"
              />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopHeader;
